import { $api, invalidateTypedQueries } from '@/api/typedClient'
import { useQueryClient } from '@tanstack/react-query'
import { message } from 'antd'

export const useCreateUserMutation = () => {
  const queryClient = useQueryClient()
  return $api.useMutation('post', '/meta/user/register', {
    onSuccess: () => {
      invalidateTypedQueries(queryClient, 'post', '/meta/user/all')
      message.success('User created successfully')
    },
    onError: (error) => {
      message.error(`Failed to create user: ${error.detail}`)
    },
  })
}

export const useUpdateUserMutation = () => {
  const queryClient = useQueryClient()
  return $api.useMutation('post', '/meta/user/update', {
    onSuccess: () => {
      invalidateTypedQueries(queryClient, 'post', '/meta/user/all')
      message.success('User updated successfully')
    },
    onError: (error) => {
      message.error(`Failed to update user: ${error.detail}`)
    },
  })
}

export const useCreateApiKeyMutation = () => {
  const queryClient = useQueryClient()
  return $api.useMutation('post', '/meta/user/api_key/create', {
    onSuccess: () => {
      invalidateTypedQueries(queryClient, 'post', '/meta/user/all')
      message.success('API key created successfully')
    },
    onError: (error) => {
      message.error(`Failed to create API key: ${error.detail}`)
    },
  })
}

export const usePasswordResetMutation = () =>
  $api.useMutation('post', '/meta/user/reset_password')

export const useEmailPasswordResetLinkMutation = () =>
  $api.useMutation('post', '/meta/user/email_password_reset_link', {
    onSuccess: () => {
      message.success('Password reset link sent')
    },
    onError: (error) => {
      message.error(`Failed to send password reset link: ${error.detail}`)
    },
  })
